<template>
	<k-button :text="text" :disabled="!userPermissions.create" @click="emitClick" variant="info" />
</template>

<script>
import KButton from "./KButton.vue";
import { mapGetters } from "vuex";
export default {
	props: {
		text: {
			type: String
		}
	},
	components: { KButton },
	computed: {
		...mapGetters(["userPermissions"])
	},
	methods: {
		emitClick: function (e) {
			this.$emit("click", e);
		}
	}
};
</script>
